import { useNavigate } from 'react-router-dom';

import { PATHS } from '../constants/routerPaths';
import {
    selectIsMainSubscriptionActive,
    selectIsOneYearMainSubscription,
    selectIsReturnOfferApplied,
} from '../store/subscriptions/selectors';

import { useSelector } from './store';

export function useReturnOfferPageProtection() {
    const navigate = useNavigate();

    const isMainSubscriptionActive: boolean = useSelector(selectIsMainSubscriptionActive);
    const isReturnOfferApplied: boolean = useSelector(selectIsReturnOfferApplied);
    const isOneYearSubscription: boolean = useSelector(selectIsOneYearMainSubscription);

    if (isReturnOfferApplied || isMainSubscriptionActive || isOneYearSubscription) {
        navigate(PATHS.MAIN);

        return;
    }
}
